import { Investment } from 'entities-next/fundingRounds'
import * as Yup from 'yup'

export type InvestmentFormData = Investment

export function getInvestmentValidation() {
  return Yup.object().shape({
    data: Yup.object()
      .test('need-relation', 'Please select either a person or a organization', function () {
        const { person, organization } = this.parent
        return !!person || !!organization
      })
      .test(
        'incompatible-investor-relations',
        'An investment cannot be made by both a person and a organization',
        function () {
          const { person, organization } = this.parent
          return !(person && organization)
        }
      ),
    isLead: Yup.boolean(),
  })
}

export function parseInvestmentToFormData({ ...otherData }: Investment): InvestmentFormData {
  return {
    ...otherData,
  }
}

export function parseFormInvestment({ organization, person, ...investmentData }: InvestmentFormData): Investment {
  return {
    ...investmentData,
    person,
    organization,
    personId: person?.id,
    organizationId: organization?.id,
  }
}
